<template>
    <div class="reg-temp-content-area main-content-height p-5">
        <div class="superadmin-dashboard-area edit-area">
            <loading v-if="loaded == false" :message="'Please wait, fetching data...'" />
            <div class="row" v-else>
                <div class="col-sm-12 col-md-7 col-lg-8">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="registered-product-item">
                                <a class="mb-3 inline-block pointer" @click.prevent="historyBack()"
                                    ><i class="fas fa-long-arrow-alt-left"></i> Back
                                </a>
                                <h3 class="mb-4">Product details</h3>
                                <ul>
                                    <serial-and-model :data="form" />
                                    <li>
                                        <span class="semibold">Date purchased</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.date_of_purchase"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="purchased_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="purchaseDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Installation date</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.installation_date"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="install_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="installationDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li class="border-b-1">
                                        <file-uploader label="Upload proof of purchase" id="proof_of_purchase" :form.sync="form" />
                                    </li>

                                    <li>
                                        <span class="semibold">Installation status</span>
                                        <span class="mt-1 coc-radio d-flex flex-column cursor-pointer">
                                            <label class="mr-2 font-normal" for="with_coc">
                                                <input
                                                    id="with_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="with_coc"
                                                />
                                                Installed with COC
                                            </label>

                                            <label class="mr-2 font-normal" for="without_coc">
                                                <input
                                                    id="without_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="without_coc"
                                                />
                                                Installation delayed
                                            </label>
                                            <label class="mr-2 font-normal" for="no_coc">
                                                <input
                                                    id="no_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="no_coc"
                                                />
                                                No coc
                                            </label>
                                        </span>
                                    </li>

                                    <div v-show="form.installation_compliance == 'with_coc'">
                                        <li>
                                            <span class="semibold">Coc number</span>
                                            <span>
                                                <input
                                                    type="text"
                                                    v-model="form.coc_number"
                                                    name="coc_number"
                                                    class="form-control"
                                                    placeholder="Coc Number"
                                            /></span>
                                        </li>
                                        <li>
                                            <file-uploader label="Upload coc certificate" id="coc_certificate" :form.sync="form" />
                                        </li>
                                    </div>
                                </ul>
                                <button class="btn btn-secondary with-white-border px-5 btn-rounded" @click.prevent="updateRegProduct()">
                                    UPDATE
                                </button>
                            </div>
                        </div>
                    </div>

                    <ApproveOwnerShipRequest :product_detail="product_detail" />

                    <ticket-box class="mt-4" :ticket_status="ticket_status" :ticket_type="ticket_type" :tickets="ticketMessages" :form="form" />
                </div>

                <div class="col-sm-12 col-md-5 col-lg-4">
                    <customer-box class="mb-4" :product_detail="product_detail" />
                    <reseller-box class="mb-4" :product_detail="product_detail" />
                    <distributor-box class="mb-4" :product_detail="product_detail" />
                    <TrackingBox :activitydetail="activitydetail" />
                    <AssignCustomerOwnership :product_detail="product_detail" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {VueAutosuggest} from 'vue-autosuggest';
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Helpers from '@/helpers/index';
import {mapGetters, mapActions} from 'vuex';
import * as _ from 'lodash';
import moment from 'moment';
import TicketBox from '@/components/WarrantyRepairBox.vue';

import customerBox from '@/views/superadmin/pageComponents/registerProduct/customer-box.vue';
import resellerBox from '@/views/superadmin/pageComponents/registerProduct/reseller-box.vue';
import distributorBox from '@/views/superadmin/pageComponents/registerProduct/distributor-box.vue';
import AssignCustomerOwnership from '@/views/superadmin/pageComponents/registerProduct/AssignCustomerOwnership.vue';
import Loading from '../../components/Loading.vue';
import TrackingBox from '@/components/TrackingBox';
import ApproveOwnerShipRequest from '@/views/superadmin/pageComponents/registerProduct/ApproveOwnerShipRequest.vue';
import bus from '@/bus';

export default {
    name: 'addRegProduct',
    components: {
        // VueAutosuggest,
        Loading,
        TicketBox,
        customerBox,
        resellerBox,
        distributorBox,
        TrackingBox,
        AssignCustomerOwnership,
        ApproveOwnerShipRequest
    },
    data() {
        return {
            activitydetail: [],
            subscribedChannel: false,
            loaded: false,
            // has_open_ticket: false,
            // message: '',
            ticketMessages: [],
            ticket_status: '',
            ticket_type: '',
            soldTo: {
                id: '',
                company: ''
            },
            serial_number_max_length: 6,

            product_detail: {},
            coc_certificate_change: '',

            form: {
                product_model: '',
                // customer: {},
                customer_id: '',
                serial_number: '',
                hasOrderNumber: false,
                order_number: '',
                sku_with_serial_number: '',
                sku_number: '',
                date_of_purchase: '',
                installation_date: '',
                installation_compliance: 'with_coc',
                // place_of_purchase: 'importer',
                coc_number: '',
                invoice_number: '',
                has_open_ticket: '',
                coc_certificate: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                },
                proof_of_purchase: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                }
            }
        };
    },
    watch: {
        // 'form.date_of_purchase': {
        //     handler(newVal) {
        //         if (this.form.installation_date && newVal && this.form.installation_date < newVal) {
        //             this.form.installation_date = null;
        //         } else if (this.form.installation_date && !newVal) {
        //             this.form.installation_date = null;
        //         }
        //     },
        //     deep: true
        // },
        // 'form.installation_date': {
        //     handler(newVal) {
        //         if (this.form.date_of_purchase && newVal && this.form.date_of_purchase > newVal) {
        //             this.form.date_of_purchase = null;
        //         } else if (this.form.date_of_purchase && !newVal) {
        //             this.form.date_of_purchase = null;
        //         }
        //     },
        //     deep: true
        // }
    },

    computed: {
        purchaseDisabledDates() {
            let disabled = {from: new Date()};
            if (this.form.installation_date) {
                const dayAfterInstall = new Date(this.form.installation_date);
                dayAfterInstall.setDate(dayAfterInstall.getDate());
                disabled.from = dayAfterInstall;
            }
            return disabled;
        },
        installationDisabledDates() {
            let disabled = {from: new Date()};
            if (this.form.date_of_purchase) {
                const dayBeforePurchase = new Date(this.form.date_of_purchase);
                dayBeforePurchase.setDate(dayBeforePurchase.getDate());
                disabled.to = dayBeforePurchase;
            }
            return disabled;
        },
        ...mapGetters({
            vg_loggedIn_user_id: 'auth/userid'
        })
    },
    async mounted() {
        let res = await this.fetchProductDetail();
        if (res) {
            this.subscribeProductChannel(res);
        }
        bus.$on('warranty-repair-box-refetch', () => {
            this.fetchProductDetail();
        });
    },

    methods: {
        historyBack() {
            history.back();
        },
        /**
         * subscribe pubnub
         */
        async subscribeProductChannel(res) {
            // const self = this;
            if (this.subscribedChannel == false) {
                let channels = [];
                channels.push(res.sku_with_serial_number);
                this.$pnSubscribe({channels: channels});
                this.$pnGetMessage(res.sku_with_serial_number, this.receiveEmit);
                this.subscribedChannel == true;
            }
        },

        receiveEmit() {
            this.fetchProductDetail();
        },

        readAbleTime(str) {
            return moment(str).format('YYYY-MM-DD hh:mm a');
        },

        /**
         * Fetch product detail by product id
         */
        fetchProductDetail() {
            const url = `${Env.baseUrl}/superadmin/reg-product/show/${this.$route.params.id}`;
            return AuthApis.getApi(url)
                .then(async (res) => {
                    this.ticketMessages = res.data.payload.tickets ? res.data.payload.tickets : [];
                    this.ticket_status = res.data.payload.ticket_status;
                    this.ticket_type = res.data.payload.ticket_type;

                    this.product_detail = res.data.payload;
                    this.form.id = res.data.payload.id;
                    this.form.product_model = res.data.payload.sku_number;
                    this.form.serial_number = res.data.payload.serial_number;
                    this.form.sku_number = res.data.payload.sku_number;
                    this.form.order_number = res.data.payload.order_number;
                    this.form.hasOrderNumber = res.data.payload.order_number ? true : false;
                    this.form.has_open_ticket = res.data.payload.has_open_ticket;
                    this.form.date_of_purchase = res.data.payload.date_of_purchase;
                    this.form.installation_date = res.data.payload.installation_date;
                    // this.form.place_of_purchase = res.data.payload.place_of_purchase;
                    this.form.coc_number = res.data.payload.coc_number ? res.data.payload.coc_number : null;
                    this.form.invoice_number = res.data.payload.invoice_number;
                    this.form.open_ticket_request = res.data.payload.open_ticket_request;
                    this.form.proof_of_purchase.incoming_url = res.data.payload.proof_of_purchase;
                    this.form.coc_certificate.incoming_url = res.data.payload.coc_certificate;

                    this.form.installation_compliance = res.data.payload.installation_compliance
                        ? res.data.payload.installation_compliance
                        : 'no_coc';

                    this.form.sold_to = res.data.payload.sold_to ? res.data.payload.sold_to.id : '';
                    this.soldTo = res.data.payload.sold_to;
                    this.$nextTick(() => {
                        var messageDiv = document.getElementById('display_messages');
                        if (messageDiv) {
                            messageDiv.scrollTop = messageDiv.scrollHeight;
                        }
                    });
                    this.activitydetail = res.data.payload.trackings || [];
                    this.loaded = true;
                    return res.data.payload;
                })
                .catch((err) => {
                    this.loaded = true;
                    return false;
                });
        },

        /**
         * Register new product
         */
        async updateRegProduct() {
            this.form.sku_with_serial_number = Helpers.getFullSerialNumber(this.form);
            this.form.installation_date = this.form.installation_date ? moment(this.form.installation_date).format('YYYY-MM-DD') : '';
            this.form.date_of_purchase = this.form.date_of_purchase ? moment(this.form.date_of_purchase).format('YYYY-MM-DD') : '';
            if (this.form.date_of_purchase && this.form.installation_date && this.form.installation_date < this.form.date_of_purchase) {
                return this.$toasted.global.error({
                    message: 'Installation date cannot be before date of purchase.'
                });
            }
            this.spinner(true);

            // pass data as form data
            let formData = new FormData();
            for (let key in this.form) {
                if (key != 'coc_certificate' && key != 'proof_of_purchase') {
                    if (this.form[key]) {
                        formData.append(key, this.form[key]);
                    }
                }
            }

            if (this.form.coc_certificate.file) {
                // uploadd file to server
                formData.append('coc_certificate', this.form.coc_certificate.file);
            } else if (this.form.coc_certificate.incoming_url == '') {
                // pass blank value to server
                formData.append('coc_certificate', '');
            }

            if (this.form.proof_of_purchase.file) {
                // uploadd file to server
                formData.append('proof_of_purchase', this.form.proof_of_purchase.file);
            } else if (this.form.proof_of_purchase.incoming_url == '') {
                // pass blank value to server
                formData.append('proof_of_purchase', '');
            }

            const url = `${Env.baseUrl}/superadmin/reg-product/update/${this.$route.params.id}`;
            AuthApis.postApi(url, formData)
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: res.data.message
                    });
                    // then return to list page
                    //this.$router.push({ name: 'SuperadminRegisteredProducts'});
                })
                .catch((err) => {
                    this.spinner(false);
                    this.$toasted.global.error({
                        message: err.response ? (err.response.data ? err.response.data.errors[0] : 'Fail.') : 'Please try again later.'
                    });
                });
        },

        isEmpty(obj) {
            if (_.isEmpty(obj)) {
                return true;
            }
            return false;
        },
        showPdf(key) {
            this.va_showPdf(true);
            this.va_setPdfObj({...this.product_detail, ...{target_key: key}});
        },
        back() {
            this.$router.push({name: 'SuperadminRegisteredProducts'});
        },
        ...mapActions({
            va_showPdf: 'pdf/setActive',
            va_setPdfObj: 'pdf/setActiveObj'
        })
    },

    beforeDestroy() {
        if (this.product_detail.sku_with_serial_number) {
            let channels = [];
            channels.push(this.product_detail.sku_with_serial_number);
            this.$pnUnsubscribe({channels: channels});
        }
        bus.$off('warranty-repair-box-refetch');
    }
};
</script>
